// Rename UploadKit's line item property before the form submits
document.addEventListener('DOMContentLoaded', function () {
  function renamePropOnSubmit(form) {
    const targets = form.querySelectorAll(
      '[name="properties[Upload a file]"], input[name="properties[Upload a file][]"], textarea[name="properties[Upload a file]"]'
    );
    targets.forEach(el => {
      el.name = el.name.replace('Upload a file', 'Show uploaded file');
    });
  }

  // Bind to all product forms
  function bindAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (form.__ukRenameBound) return;
      form.addEventListener('submit', () => renamePropOnSubmit(form), true); // capture, before app handlers
      form.__ukRenameBound = true;
    });
  }

  bindAll();
  // If the app injects/replaces forms dynamically
  new MutationObserver(bindAll).observe(document.documentElement, { childList: true, subtree: true });
});




// Accordian (skip canva-2 — uses animated accordion in teeinblue-custom.liquid)
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('template-suffix-canva-2')) return;
  // Select all of our custom accordions
  const accordions = document.querySelectorAll('.custom-product-accordion details');

  accordions.forEach(accordion => {
    // Listen for a click on the summary (the header)
    const summary = accordion.querySelector('summary');
    
    summary.addEventListener('click', function(e) {
      // Check if the clicked accordion is currently closed
      if (!accordion.hasAttribute('open')) {
        
        // Loop through all accordions and close the others
        accordions.forEach(otherAccordion => {
          if (otherAccordion !== accordion && otherAccordion.hasAttribute('open')) {
            otherAccordion.removeAttribute('open');
          }
        });
        
      }
    });
  });
});


